export default "__VITE_ASSET__Ckp0Nxtz__"